/* tslint:disable */
/* eslint-disable */
/* @relayHash d94d565d87a5457e4a1f9154e152fc7e */

import { ConcreteRequest } from "relay-runtime";
export type STORY_STATUS = "CLOSED" | "OPEN" | "%future added value";
export type UnarchiveStoriesInput = {
    clientMutationId: string;
    storyIDs: Array<string>;
};
export type UnarchiveStoriesMutationVariables = {
    input: UnarchiveStoriesInput;
};
export type UnarchiveStoriesMutationResponse = {
    readonly unarchiveStories: {
        readonly stories: ReadonlyArray<{
            readonly id: string;
            readonly status: STORY_STATUS;
            readonly isArchived: boolean;
            readonly isArchiving: boolean;
            readonly isUnarchiving: boolean;
        }>;
        readonly clientMutationId: string;
    };
};
export type UnarchiveStoriesMutation = {
    readonly response: UnarchiveStoriesMutationResponse;
    readonly variables: UnarchiveStoriesMutationVariables;
};



/*
mutation UnarchiveStoriesMutation(
  $input: UnarchiveStoriesInput!
) {
  unarchiveStories(input: $input) {
    stories {
      id
      status
      isArchived
      isArchiving
      isUnarchiving
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UnarchiveStoriesPayload",
            "kind": "LinkedField",
            "name": "unarchiveStories",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stories",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchived",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchiving",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnarchiving",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UnarchiveStoriesMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UnarchiveStoriesMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "d94d565d87a5457e4a1f9154e152fc7e",
            "metadata": {},
            "name": "UnarchiveStoriesMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'f0913805ae0070355825666008e7740b';
export default node;
